/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ total: NonNullable<unknown> }} Deal_Splits_Total_PercentInputs */

const cs_deal_splits_total_percent = /** @type {(inputs: Deal_Splits_Total_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Celkem přiděleno: ${i?.total} %`)
};

const en_deal_splits_total_percent = /** @type {(inputs: Deal_Splits_Total_PercentInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Total allocated: ${i?.total}%`)
};

/**
* | output |
* | --- |
* | "Total allocated: {total}%" |
*
* @param {Deal_Splits_Total_PercentInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const deal_splits_total_percent = /** @type {((inputs: Deal_Splits_Total_PercentInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Deal_Splits_Total_PercentInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_deal_splits_total_percent(inputs)
	return cs_deal_splits_total_percent(inputs)
});